/** Sistem durumu tipleri — V2 Faz F. */

export interface StatusComponent {
  Id: string;
  Key: string;
  Name: string;
  Description: string | null;
  Status: string;
  SortOrder: number;
}

export interface StatusIncident {
  Id: string;
  Title: string;
  Body: string | null;
  Impact: string;
  Status: string;
  StartedAt: string;
  ResolvedAt: string | null;
  ComponentName: string | null;
}

export interface StatusOverview {
  /** En kötü bileşenin durumu — bir bileşen çökmüşken "yolunda" denmez. */
  OverallStatus: string;
  Components: StatusComponent[];
  Incidents: StatusIncident[];
}

export const COMPONENT_STATUSES = [
  "operational",
  "degraded",
  "partial_outage",
  "major_outage",
  "maintenance",
] as const;

export const INCIDENT_STATUSES = ["investigating", "identified", "monitoring", "resolved"] as const;

export const STATUS_COLOR: Record<string, string> = {
  operational: "success",
  maintenance: "info",
  degraded: "warning",
  partial_outage: "warning",
  major_outage: "danger",
};

export const STATUS_LABEL: Record<string, string> = {
  operational: "Çalışıyor",
  maintenance: "Bakımda",
  degraded: "Yavaş",
  partial_outage: "Kısmi kesinti",
  major_outage: "Kesinti",
};
